export const API_PATH_ApiAlertMgtmAlertHandlingGet = '/services/alerts-mgtm/apiAlertMgtmAlertHandlingGet';
